import React from 'react';
import PhotographyLayout from '../../components/photography/PhotographyLayout';
import Hero from '../../components/photography/Hero';
import InstagramGrid from '../../components/photography/InstagramGrid';

export default function PhotographyHome() {
  return (
    <PhotographyLayout>
      <Hero />
      <InstagramGrid />
      {/* Nanti kita tambahkan <AboutPreview /> dan <ContactStrip /> di bawah sini */}
    </PhotographyLayout>
  );
}